import { render } from "./Index.vue?vue&type=template&id=7ec75246"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Projects/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ec75246"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ec75246', __exports__)) {
    console.log('reload')
    api.reload('7ec75246', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=7ec75246", () => {
    console.log('re-render')
    api.rerender('7ec75246', render)
  })

}


export default __exports__